import * as React from "react";

const User: React.FC = () => {
    return (
        <svg width="18" height="24" viewBox="0 0 18 24" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9 13.25A8.75 8.75 0 0117.75 22l-.006.128A1.25 1.25 0 0116.5 23.25h-15C.81 23.25.25 22.69.25 22l.004-.258A8.75 8.75 0 019 13.25zM9 .75a5 5 0 110 10l-.217-.005A5 5 0 014 5.75l.005-.217A5 5 0 019 .75z"
                fill="currentColor"
            />
        </svg>
    );
};

export default React.memo(User);
